import $ from "jquery";

const toast = () => {
    const init = () => {
        // Can be called elsewhere using: window.showToast()
        window.showToast = showToast;
    };

    const showToast = (message, duration = 2000) => {
        const $toastParent = $('#mi-toast');
        const $toast = $('#mi-toast .mi-toast-text');

        if ($toastParent.length) {
            $toast.text(message);

            // Add the 'show' class to start the animation
            $toastParent.addClass('show').removeClass("hide");

            // Hide the toast after the specified duration
            setTimeout(() => {
                $toastParent.addClass('hide').removeClass('show');
            }, duration);
        }
    };

    init();
};

try {
    toast();
} catch (error) {
    console.error('toast', error);
}
